<template>
  <div class="profile-page">
    <!-- 导航栏 -->
    <Navbar />

    <div class="main-content">
      <!-- 侧边栏菜单 -->
      <div class="sidebar">
        <el-menu
          :default-active="activeMenu"
          class="profile-menu"
          @select="handleMenuSelect"
        >
          <el-menu-item index="overview">
            <i class="el-icon-data-board"></i>
            <span>Visão geral</span>
          </el-menu-item>
          <el-menu-item index="orders">
            <i class="el-icon-shopping-bag-2"></i>
            <span>Pedidos</span>
          </el-menu-item>
          <el-menu-item index="favorites">
            <i class="el-icon-star-on"></i>
            <span>Favoritos</span>
          </el-menu-item>
          <!-- <el-menu-item index="addresses">
            <i class="el-icon-location"></i>
            <span>Endereços de entrega</span>
          </el-menu-item> -->
          <!-- <el-menu-item index="coupons">
            <i class="el-icon-ticket"></i>
            <span>Cupons</span>
          </el-menu-item> -->
          <!-- <el-menu-item index="points">
            <i class="el-icon-coin"></i>
            <span>Registro de pontos</span>
          </el-menu-item> -->
          <el-menu-item index="profile">
            <i class="el-icon-user"></i>
            <span>Perfil</span>
          </el-menu-item>

          <el-menu-item index="logout">
            <i class="el-icon-switch-button"></i>
            <span>Sair</span>
          </el-menu-item>
          <!-- <el-menu-item index="security">
            <i class="el-icon-lock"></i>
            <span>Configurações de segurança</span>
          </el-menu-item> -->
        </el-menu>
      </div>

      <!-- 主要内容区域 -->
      <div class="content-area">
        <!-- 概览页面 -->
        <div v-if="activeMenu === 'overview'" class="overview-content">
          <div class="welcome-section">
            <div class="user-welcome">
              <div style="width: 80px;">
                <el-avatar :size="80" :src="userInfo.avatar || ''"></el-avatar>
              </div>
              <div class="welcome-text">
                <h2>Bem-vindo {{ userInfo.nickname }}!</h2>
                <!-- <p>{{ userInfo.memberLevel }} | 积分：{{ userInfo.points }}</p> -->
              </div>
            </div>
            <div class="quick-stats">
              <div class="stat-card">
                <div class="stat-number">{{ orderStats.order }}</div>
                <div class="stat-label">Todos</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">{{ orderStats.status10 || "0" }}</div>
                <div class="stat-label">Confirmado</div>
              </div>
              <div class="stat-card"> 
                <div class="stat-number">{{ orderStats.status20 || "0" }}</div>
                <div class="stat-label">Enviado</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">{{ orderStats.collect }}</div>
                <div class="stat-label">Favoritos</div>
              </div>
            </div>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-card class="recent-orders">
                <div slot="header">
                  <span>Pedidos recentes</span>
                  <el-button style="float: right; padding: 3px 0" type="text" @click="activeMenu = 'orders'">Ver tudo</el-button>
                </div>
                <div v-for="order in recentOrders" :key="order.order_id" class="order-item">
                  <div class="order-info">
                    <div class="order-number" style="font-size: 14px;">Número do pedido: {{ order.order_sn }}</div>
                    <div class="order-time" style="font-size: 12px;">{{ order.create_time }}</div>
                    <div class="order-status" :class="'status'+order.status">{{ (order.status_desc) }}</div>
                  </div>
                  <div class="order-amount">R${{ order.pay_amount }}</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="recent-favorites">
                <div slot="header">
                  <span>Coleções recentes</span>
                  <el-button style="float: right; padding: 3px 0" type="text" @click="activeMenu = 'favorites'">Ver tudo</el-button>
                </div>
                <div v-for="item in recentFavorites" :key="item.id" class="favorite-item">
                  <img :src="item.image" class="favorite-image">
                  <div class="favorite-info">
                    <div class="favorite-name">{{ item.name }}</div>
                    <div class="favorite-price">¥{{ item.price }}</div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>

        <!-- 我的订单 -->
        <div v-if="activeMenu === 'orders'" class="orders-content">
          <h2 style="margin-bottom: 20px;">Meus pedidos</h2>
          <el-tabs v-model="orderQuery.status" @tab-click="handleOrderTabClick">
            <el-tab-pane label="Todos" name="all"></el-tab-pane>
            <el-tab-pane label="Processando" name="status10"></el-tab-pane>
            <el-tab-pane label="Enviado" name="status20"></el-tab-pane>
            <el-tab-pane label="Concluído" name="status30"></el-tab-pane>
          </el-tabs>
          
          <div class="order-list">
            <!-- 订单列表为空时显示空状态 -->
            <div v-if="orderList.length === 0" class="empty-state">
              <el-empty description="Nenhum pedido encontrado">
                <el-button type="primary" @click="$router.push('/')">Ir shopping</el-button>
              </el-empty>
            </div>
            <!-- 订单列表不为空时显示订单卡片 -->
            <el-card v-else v-for="order in orderList" :key="order.id" class="order-card">
              <div class="order-header">
                <span class="order-number">Número do pedido: {{ order.order_sn }}</span>
                <span class="order-date">{{ order.create_time }}</span>
                <span class="order-status" :class="order.status">{{ order.status_desc || '-' }}</span>
              </div>
              <div class="order-products">
                <div v-for="product in order.items" :key="product.id" class="product-item">
                  <img :src="product.goods_image" class="product-image">
                  <div class="product-info">
                    <div class="product-name">{{ product.goods_name }}</div>
                    <div class="product-sku">{{ product.code }}</div>
                    <div class="product-spec">{{ product.spec_name || '-' }}</div>
                  </div>
                  <div class="product-price">R$ {{ product.spec_price }}</div>
                  <div class="product-quantity">x{{ product.nums }}</div>
                </div>
              </div>
              <div class="order-footer">
                <div class="order-total">Total:R$ {{ order.pay_amount }}</div>
                <div class="order-actions">
                  <!-- <el-button v-if="order.status === 'pending'" type="primary" size="small">立即付款</el-button>
                  <el-button v-if="order.status === 'shipping'" type="primary" size="small">确认收货</el-button>
                  <el-button v-if="order.status === 'completed'" size="small">再次购买</el-button> -->
                  <el-button type="primary" size="small" @click="goToOrderDetail(order)">Ver detalhes</el-button>
                </div>
              </div>
            </el-card>
          </div>
          <!-- 需要写一个分页 动态获取数据 -->
          <div class="pagination-container">
            <pagination v-show="orderTotal>0" layout="prev, pager, next" :total="orderTotal" :page.sync="orderQuery.page" :limit.sync="orderQuery.size"
							@pagination="getOrderFun" />
          </div>
        </div>


        <!-- 我的收藏 -->
        <div v-if="activeMenu === 'favorites'" class="favorites-content">
          <h2 style="margin-bottom: 20px;">Minha coleção</h2>
          <el-row :gutter="20" v-if="favorites.length > 0">

            <el-col :span="6" v-for="item in favorites" :key="item.collect_id">
              <el-card :body-style="{ padding: '0px' }" class="favorite-card">
                <img :src="item.image" class="favorite-card-image">
                <div class="favorite-card-content">
                  <h3>{{ item.name }}</h3>
                  <div class="favorite-card-price">¥{{ item.price }}</div>
                  <div class="favorite-card-actions">
                    <el-button type="primary" size="small">Adicionar ao carrinho</el-button>
                    <el-button size="small" @click="removeFavorite(item.collect_id)">Cancelar a coleção</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-row v-else>
              <el-empty description="Nenhuma coleção"></el-empty>
          </el-row>
        </div>

        <!-- Endereços de entrega -->
        <div v-if="activeMenu === 'addresses'" class="addresses-content">
          <div class="addresses-header">
            <h2>Endereços de entrega</h2>
            <el-button type="primary" @click="showAddressDialog = true">Adicionar novo endereço</el-button>
          </div>
          <el-row :gutter="20">
            <el-col :span="8" v-for="address in addresses" :key="address.id">
              <el-card class="address-card" :class="{ 'default-address': address.isDefault }">
                <div class="address-info">
                  <div class="address-name">{{ address.name }} {{ address.phone }}</div>
                  <div class="address-detail">{{ address.province }} {{ address.city }} {{ address.district }} {{ address.detail }}</div>
                  <div class="address-actions">
                    <el-button type="text" @click="editAddress(address)">Editar</el-button>
                    <el-button type="text" @click="deleteAddress(address.id)">Excluir</el-button>
                    <el-button v-if="!address.isDefault" type="text" @click="setDefaultAddress(address.id)">Definir como padrão</el-button>
                  </div>
                </div>
                <div v-if="address.isDefault" class="default-tag">Padrão</div>
              </el-card>
            </el-col>
          </el-row>
        </div>

        <!-- 个人资料 -->
        <div v-if="activeMenu === 'profile'" class="profile-content">
          <h2 style="margin-bottom: 20px;">Perfil</h2>
          <el-form :model="userInfo" :rules="profileRules" ref="profileForm" label-width="120px">
            <el-form-item label="Avatar">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :http-request="handleAvatarUpload"
              >
                <img v-if="userInfo.avatar" :src="userInfo.avatar || ''" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="Nome" prop="nickname">
              <el-input v-model="userInfo.nickname"></el-input>
            </el-form-item>
            <el-form-item label="E-mail" prop="email">
              <el-input v-model="userInfo.email"></el-input>
            </el-form-item>
            <el-form-item label="Empresa" prop="company_name">
              <el-input v-model="userInfo.company_name"></el-input>
            </el-form-item>
            <el-form-item label="CNPJ" prop="tax_number">
              <el-input v-model="userInfo.tax_number"></el-input>
            </el-form-item>
            <el-form-item label="Endereço" prop="address">
              <el-input v-model="userInfo.address"></el-input>
            </el-form-item>
            <el-form-item label="WhatsApp" prop="mobile">
              <el-input v-model="userInfo.mobile"></el-input>
            </el-form-item>
            <el-form-item label="Senha" prop="password">
              <el-input v-model="password" type="password" placeholder="Deixe em branco para não alterar"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="updateProfile">Salvar as alterações</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- Diálogo de edição de endereço -->
    <el-dialog
      :title="addressDialogTitle"
      :visible.sync="showAddressDialog"
      width="500px"
    >
      <el-form :model="addressForm" :rules="addressRules" ref="addressForm" label-width="80px">
        <el-form-item label="Nome" prop="name">
          <el-input v-model="addressForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Telefone" prop="phone">
          <el-input v-model="addressForm.phone"></el-input>
        </el-form-item>
        <el-form-item label=" província, cidade, distrito" prop="region">
          <el-cascader
            v-model="addressForm.region"
            :options="regionOptions"
            placeholder="Selecione província, cidade, distrito"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="Endereço Detalhado" prop="detail"> 
          <el-input v-model="addressForm.detail" type="textarea" rows="3"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="addressForm.isDefault">Definir como endereço padrão</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddressDialog = false">Cancelar</el-button>
        <el-button type="primary" @click="saveAddress">Salvar</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { mapGetters, mapActions } from 'vuex'
import { getUserInfo2, updateUserInfo, uploadImage } from '@/api/user'
import { getMyFavoriteGoods,collectGoods,uncollectGoods } from "@/api/product"
import { homeStat } from '@/api/home'
import { orderPage } from '@/api/order'
import Pagination from '@/components/Pagination/index.vue'


export default {
  name: 'ProfilePage',
  components: {
    Navbar,
    Pagination
  },
  data() {
    return {
      activeIndex: '3',
      activeMenu: 'overview',
      orderTab: 'all',
      showAddressDialog: false,
      editingAddressId: null,
      
      password: '',
      orderStats: {
        order: 0,
        collect: 0,
        status10: 0,
        status20: 0,
        status30: 0,

      },
      orderTotal: 0,
      orderList: [],
      orderQuery: {
        page: 1,
        size: 10,
        status: 'all'
      },
      favorites: [],
      addresses: [],
      addressForm: {
        name: '',
        phone: '',
        region: [],
        detail: '',
        isDefault: false
      },
      regionOptions: [],
      profileRules: {
        nickname: [
          { required: true, message: 'Por favor, insira o apelido', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Por favor, insira o e-mail', trigger: 'blur' },
          { type: 'email', message: 'Digite o formato correto do e-mail', trigger: 'blur' }
        ],
        tax_number: [
          { required: true, message: 'Por favor, insira o NIF', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Por favor, insira o endereço', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: 'Por favor, insira o número de telefone', trigger: 'blur' }
        ],
        company_name: [
          { required: true, message: 'Por favor, insira o nome da empresa', trigger: 'blur' }
        ]
      },
      addressRules: {
        name: [
          { required: true, message: 'Por favor, insira o nome', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择省市区', trigger: 'change' }
        ],
        detail: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'isLoggedIn']),
    recentOrders() {
      return this.orderList.slice(0, 3)
    },
    recentFavorites() {
      return this.favorites.slice(0, 3)
    },
    // filteredOrders() {
    //   if (this.orderTab === 'all') {
    //     return this.orderList
    //   }
    //   return this.orderList.filter(order => order.status === this.orderTab)
    // },
    
    addressDialogTitle() {
      return this.editingAddressId ? 'Editar endereço' : 'Adicionar endereço'
    }
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.$message.warning('Por favor, inicie sessão')
      this.$router.push('/')
      return
    }
    this.getHomeStatFun()
    this.getFavoriteFun()
    this.getOrderFun()
  },
  methods: {
     ...mapActions('user', ['getUserInfo']),
     logout(){
      // logout
      this.$confirm('Tem a certeza de que deseja sair do login?', 'Dicas', {
        confirmButtonText: 'Certo.',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        // 调用 store 中的 logout action，同时清理 state 和 localStorage 中的 token
        this.$store.dispatch('user/logout')
        
        this.$router.replace('/')
      }).catch(err=>{
        console.log('err',err)
      })
     },
     goToOrderDetail(item){
      // console.log("item",item);return;
      this.$router.push({
        name: 'OrderDetail',
        query: {
          id: item.order_id
        }
      })
     
    },
      getFavoriteFun(){
        getMyFavoriteGoods({page: 1, size: 50}).then(res => {
          this.favorites = res.data.lists
        }).catch(err=>{
        console.log('err',err)
      })
      },
      getOrderFun(){
        orderPage(this.orderQuery).then(res => {
          this.orderList = res.data.lists
          this.orderTotal = res.data.total
        }).catch(err=>{
        console.log('err',err)
      })
      },


    getHomeStatFun(){
      homeStat().then(res => {
        this.orderStats = res.data
      }).catch(err=>{
        console.log('err',err)
      })
    },

    
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.activeMenu = 'profile'
          break
        case 'settings':
          this.activeMenu = 'security'
          break
        case 'logout':
          this.logout()
          break
      }
    },
    handleMenuSelect(index) {
      // console.log('index',index)
      if(index === 'logout'){
        this.logout()
        return;
      }
      this.activeMenu = index
    },
    handleOrderTabClick(tab) {
      // this.orderTab = tab.name
      this.orderQuery.page = 1;
      this.getOrderFun();
    },
    getOrderStatusText(status) {
      const statusMap = {
        pending: 'Pagamento pendente',
        processing: 'Pendente envio',
        shipping: 'Pendente recepção',
        completed: 'Concluído',
        cancelled: 'Cancelado'
      }
      return statusMap[status] || 'Desconhecido'
    },
    removeFavorite(id) {
      this.favorites = this.favorites.filter(item => item.id !== id)
      uncollectGoods({id}).then(res=>{
        this.$message.success('Coleção cancelada')
        this.getFavoriteFun()

      }).catch(err=>{
        console.log('err',err)
      })
    },
    editAddress(address) {
      this.editingAddressId = address.id
      this.addressForm = {
        name: address.name,
        phone: address.phone,
        region: [address.province, address.city, address.district],
        detail: address.detail,
        isDefault: address.isDefault
      }
      this.showAddressDialog = true
    },
    deleteAddress(id) {
      this.$confirm('Tem certeza que deseja excluir este endereço?', 'Aviso', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addresses = this.addresses.filter(addr => addr.id !== id)
        this.$message.success('Endereço excluído com sucesso')
      })
    },
    setDefaultAddress(id) {
      this.addresses.forEach(addr => {
        addr.isDefault = addr.id === id
      })
      this.$message.success('Endereço padrão definido com sucesso')
    },
    saveAddress() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          if (this.editingAddressId) {
            // Editar endereço
            const index = this.addresses.findIndex(addr => addr.id === this.editingAddressId)
            if (index !== -1) {
              this.addresses[index] = {
                ...this.addresses[index],
                ...this.addressForm,
                province: this.addressForm.region[0],
                city: this.addressForm.region[1],
                district: this.addressForm.region[2]
              }
            }
            this.$message.success('地址已更新')
          } else {
            // Adicionar novo endereço
            const newAddress = {
              id: Date.now(),
              ...this.addressForm,
              province: this.addressForm.region[0],
              city: this.addressForm.region[1],
              district: this.addressForm.region[2]
            }
            this.addresses.push(newAddress)
            this.$message.success('地址已添加')
          }
          
          this.showAddressDialog = false
          this.editingAddressId = null
          this.$refs.addressForm.resetFields()
        }
      })
    },
    updateProfile() {
      this.$refs.profileForm.validate((valid) => {
        if (valid) {
          const params = { ...this.userInfo }
          if (this.password) {
            params.password = this.password
          }
          updateUserInfo(params).then(res => {
            // console.log('res',res)
            this.getUserInfoFun()
            this.password = ''
            this.$message.success('Perfil atualizado')
          }).catch(err=>{
        console.log('err',err)
      })
        }
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isJPG) {
        this.$message.error('Enviar imagens de avatar só pode ser no formato JPG / PNG!')
      }
      if (!isLt2M) {
        this.$message.error('O tamanho da imagem não pode exceder 2MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarUpload(uploadFile) {
      const file = uploadFile.file
      const formData = new FormData()
      //上传图片的时候 需要获取图片的本地临时文件,然后filePath上传
      // const filePath = URL.createObjectURL(file)
      //不对  上传的filePath 是一个本地临时文件路径,不是图片路径
      // 应该上传file 而不是filePath
      formData.append('file', file)

      uploadImage(formData).then(res=>{
        console.log('res',res)
        if(res&&res.data){
          this.$message.success('Avatar enviado com sucesso')
          // 更新用户信息中的头像
          this.userInfo.avatar = res.data
          this.updateProfile()
         
        }
      })


      
      // uploadAvatar(formData).then(res => {
      //   if (res.status === 200) {
      //     this.$message.success('Avatar enviado com sucesso')
      //     // 更新用户信息中的头像
      //     this.userInfo.avatar = res.data.avatar
      //     this.updateProfile()
      //     // 同步更新vuex中的用户信息
      //     this.getUserInfo()
      //   } else {
      //     this.$message.error('Falha no envio do avatar')
      //   }
      // }).catch(err => {
      //   console.error('upload error:', err)
      //   this.$message.error('Falha no envio do avatar')
      // })
    },
   
  }
}
</script>

<style lang="scss" scoped>
.profile-page{
  margin-top: 100px
}
.header {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 0;
  margin-bottom: 20px;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 60px;
}

.logo h2 {
  margin: 0;
  color: #ff6b6b;
}

.nav-menu {
  border-bottom: none;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.username {
  margin: 0 8px;
  color: #333;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  gap: 20px;
}

.sidebar {
  width: 200px;
  flex-shrink: 0;
}

.profile-menu {
  border-right: none;
  background-color: #f8f9fa;
}

.profile-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.content-area {
  flex: 1;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.welcome-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8a80 100%);
  border-radius: 8px;
  color: white;
}

.user-welcome {
  display: flex;
  align-items: center;
  gap: 20px;
}

.welcome-text h2 {
  margin: 0 0 5px 0;
  font-size: 24px;
}

.welcome-text p {
  margin: 0;
  opacity: 0.9;
}

.quick-stats {
  display: flex;
  gap: 20px;
}

.stat-card {
  text-align: center;
  background: rgba(255,255,255,0.2);
  padding: 15px;
  border-radius: 8px;
  min-width: 80px;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
}

.recent-orders,
.recent-favorites {
  margin-bottom: 20px;
}

.order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.order-item:last-child {
  border-bottom: none;
}

.order-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.order-header {
  font-size: 14px;
  color: #666;
}

.order-status{
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background-color: #fff3cd;
}
.order-status.pending {
  background: #fff3cd;
  color: #856404;
}

.order-status.shipping {
  background: #d1ecf1;
  color: #0c5460;
}

.order-status.completed {
  background: #d4edda;
  color: #155724;
}

.order-amount {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}

.favorite-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.favorite-item:last-child {
  border-bottom: none;
}

.favorite-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
}

.favorite-info {
  flex: 1;
}

.favorite-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 2px;
}

.favorite-price {
  font-size: 12px;
  color: #ff6b6b;
  font-weight: bold;
}

.order-list {
  margin-top: 20px;
}

.order-card {
  margin-bottom: 20px;
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.order-products {
  margin-bottom: 15px;
}

.product-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px 0;
}

.product-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.product-info {
  flex: 1;
  display: flex;
  align-items: center;
}

.product-name {
  font-size: 14px;
}

.product-sku{
  width: 140px;
  font-size: 14px;
}

.product-spec {
  width: 140px;
  font-size: 14px;
}

.product-price {
  width: 80px;
  font-size: 14px;
  text-align: right;
}

.product-quantity {
  color: #666;
  width: 60px;
  font-size: 14px;
  text-align: right;
}

.order-footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.order-total {
  font-size: 16px;
  font-weight: bold;
  color: #e60013;
}

.order-actions {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

.favorite-card {
  margin-bottom: 20px;
  cursor: pointer;
  transition: transform 0.3s;
}

.favorite-card:hover {
  transform: translateY(-2px);
}

.favorite-card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.favorite-card-content {
  padding: 15px;
}

.favorite-card-content h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.favorite-card-price {
  color: #ff6b6b;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.favorite-card-actions {
  display: flex;
  gap: 10px;
}

.addresses-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.address-card {
  position: relative;
  margin-bottom: 20px;
}

.address-card.default-address {
  border-color: #ff6b6b;
}

.address-info {
  padding: 5px;
}

.address-name {
  font-weight: bold;
  margin-bottom: 8px;
}

.address-detail {
  color: #666;
  margin-bottom: 10px;
  line-height: 1.5;
}

.address-actions {
  display: flex;
  gap: 10px;
}

.default-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ff6b6b;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .el-upload {
    width: 100px;
    height: 100px;
  }
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}

.dialog-footer {
  text-align: right;
}
</style>